import React from 'react';
import {CreditCard} from "lucide-react";
import RenderIf from "@/components/render-if";
import {formatDate} from "@/lib/helper/date";
import {useParams} from "react-router-dom";

function InstallmentSection({data}) {

    const param = useParams();
    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return 'bg-orange-100 text-orange-800 border-orange-200';
            case 'submitted':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'graded':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'inventory_deduction':
            case 'paid':
            case 'full_payed':
                return 'bg-green-100 text-green-800 border-green-200';
            default:
                return 'bg-gray-100  border-gray-200';
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fa-IR').format(amount);
    };

    return (
        <>
            {/* Payment Status */}
            <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-green-100 rounded-lg">
                        <CreditCard className="w-6 h-6 text-green-600"/>
                    </div>
                    <h3 className="text-lg font-semibold ">وضعیت اقساط</h3>
                </div>
                <RenderIf condition={data?.data?.data?.installments?.length > 0}>
                    <div className="space-y-4">
                        {data?.data?.data?.installments.map((installation, index) => (
                            <div key={'lesson-detail' + param.id + '-' + 'installment' + installation.id}
                                 className="flex items-center justify-between p-3 border rounded-lg">
                                <div>
                                    <p className="font-medium "> قسط {index + 1}</p>
                                    <p className="text-sm ">تاریخ
                                        سررسید{formatDate(installation.duedate)}</p>
                                    <RenderIf condition={installation?.date_payed}>
                                        <p className="text-sm "> تاریخ
                                            پرداخت{formatDate(installation.date_payed)}</p>
                                    </RenderIf>
                                </div>
                                <div className="text-left">
                                    <p className="font-semibold">{formatCurrency(installation.price)} تومان</p>
                                    <span
                                        className={`inline-block px-2 py-1 rounded text-xs font-medium ${getStatusColor(installation.pay_status)}`}>
                        {
                            installation.pay_status === 'full_payed' ? 'پرداخت شده' :
                                installation.pay_status === 'pending' ?  'در انتظار' :
                                    installation.pay_status === 'inventory_deduction' ? 'پرداخت شده از طریق کسر از حساب' : '-'

                        }
                      </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </RenderIf>

            </div>
        </>
    );
}

export default InstallmentSection;